import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export interface AlertBoardTheme {
  container: {
    backgroundColor: string;
  };
  title: {
    color: string;
  };
  plantName: {
    color: string;
  };
  icons: {
    primary: string;
    secondary: string;
    tertiary: string;
  };
  dateSelector: {
    backgroundColor: string;
    innerBackgroundColor: string;
    textColor: string;
  };
  controls: {
    borderColor: string;
    filterLabel: {
      color: string;
    };
    filterDropdown: {
      backgroundColor: string;
      borderColor: string;
      textColor: string;
    };
    organizeButton: {
      backgroundColor: string;
      activeBackgroundColor: string;
      iconColor: string;
      activeIconColor: string;
    };
  };
  grid: {
    backgroundColor: string;
  };
  header: {
    container: {
      backgroundColor: string;
    };
    title: {
      color: string;
    };
    organizeButton: {
      backgroundColor: string;
      activeBackgroundColor: string;
      iconColor: string;
      activeIconColor: string;
      hoverBackgroundColor: string;
    };
    organizeLabel: {
      color: string;
    };
    timeDropdown: {
      backgroundColor: string;
      borderColor: string;
      textColor: string;
      iconColor: string;
    };
    toggleGroup: {
      backgroundColor: string;
      borderColor: string;
    };
  };
}

export const alertBoardTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      container: {
        backgroundColor: theme.color.surface[3],
      },
      title: {
        color: theme.color.text.core['-primary'],
      },
      plantName: {
        color: theme.color.text.core['-secondary'],
      },
      icons: {
        primary: theme.color.text.core['-primary'],
        secondary: theme.color.text.core['-secondary'],
        tertiary: theme.color.text.core['-tertiary'],
      },
      dateSelector: {
        backgroundColor: theme.color.surface[4],
        innerBackgroundColor: theme.color.surface[2],
        textColor: theme.color.text.core['-secondary'],
      },
      controls: {
        borderColor: theme.color.surface[4],
        filterLabel: {
          color: theme.color.text.core['-primary'],
        },
        filterDropdown: {
          backgroundColor: theme.color.surface[1],
          borderColor: theme.color.surface[4],
          textColor: theme.color.text.core['-tertiary'],
        },
        organizeButton: {
          backgroundColor: 'transparent',
          activeBackgroundColor: 'transparent',
          iconColor: theme.color.text.core['-secondary'],
          activeIconColor: theme.color.focus[4],
        },
      },
      grid: {
        backgroundColor: theme.color.surface[4],
      },
      header: {
        container: {
          backgroundColor: theme.color.surface[3],
        },
        title: {
          color: theme.color.text.core['-primary'],
        },
        organizeButton: {
          backgroundColor: theme.color.surface[1],
          activeBackgroundColor: theme.color.surface[1],
          iconColor: theme.color.text.core['-tertiary'],
          activeIconColor: theme.color.text.core['-primary'],
          hoverBackgroundColor: theme.color.surface[2],
        },
        organizeLabel: {
          color: theme.color.text.core['-secondary'],
        },
        timeDropdown: {
          backgroundColor: theme.color.surface[1],
          borderColor: theme.color.surface[3],
          textColor: theme.color.text.core['-primary'],
          iconColor: theme.color.text.core['-secondary'],
        },
        toggleGroup: {
          backgroundColor: theme.color.surface[4],
          borderColor: theme.color.surface[4],
        },
      },
    },
  ]),
);
